// Live Preview Fancybox Pop up - Floori
(async () => {

  if(!customElements.get('product-live-preview')) {

    const { Fancybox } = await import("@fancyapps/ui");

    class productLivePreview extends HTMLElement {

      constructor() {
        super();

        // Live preview iframe settings
        const livePreviewButton = this.querySelector('[data-product-live-preview]');
        livePreviewButton.addEventListener('click', () => {
          let src = livePreviewButton.dataset.src;
          Fancybox.show(
            [
              {
                src: src,
                type: "iframe",
              }
            ],
            {
              mainClass: "fancybox__container--floori"
            }
          );
          return false;
        });
      }

    }

    window.productLivePreview = productLivePreview;
    customElements.define('product-live-preview', productLivePreview);

  }
})();
